export const processEnum = Object.freeze({
	None: 0,
	EditGrid: 1,
	DebugInitialDataSeed: 2,
	DataImport: 3,
	InventoryForm: 4,
	WorkdayIntegrationService: 5,
	HydraIntegrationService: 6,
	MobileApi: 7,
	Merge: 8,
});

export function getIrisProcessDisplayFormat(process) {
	switch (process) {
		case processEnum.None:
			return 'None';
		case processEnum.EditGrid:
			return 'Edit Grid';
		case processEnum.DebugInitialDataSeed:
			return 'Debug Initial Data Seed';
		case processEnum.DataImport:
			return 'Data Import';
		case processEnum.InventoryForm:
			return 'Inventory Form';
		case processEnum.WorkdayIntegrationService:
			return 'Workday Integration Service';
		case processEnum.HydraIntegrationService:
			return 'Hydra Integration Service';
		case processEnum.MobileApi:
			return 'Mobile';
		case processEnum.Merge:
			return 'Merge';
		default:
			return '';
	}
}
